import { useCallback, useMemo } from "react";

import type { SiteControllerSettingBaseFormModel } from "@/components/features/settings/site-controller/model/base/type";
import type { SiteControllerSettingTllFormModel } from "@/components/features/settings/site-controller/model/tl-lincoln/type";
import type { SiteControllerSettingTLLincolnFormModelMethodsType } from "@/components/features/settings/site-controller/model/tl-lincoln/use-case/use-create-model/methods";

import type { FormOptionType } from "@/components/ui/form/_types/type";

type Props = {
	rooms: SiteControllerSettingTllFormModel["ViewModel"]["tll"]["rooms"]; //
	onSetChillnnRoomID: SiteControllerSettingTLLincolnFormModelMethodsType["siteControllerSettingTLLFormModelMethods"]["onSetChillnnRoomID"];

	roomKVList: SiteControllerSettingBaseFormModel["QueryData"]["roomKVList"];
};

const NULL = "null";

export const useTlLincolnSetChillnnRoomID = ({ rooms, onSetChillnnRoomID: _onSetChillnnRoomID, roomKVList }: Props) => {
	const selectedChillnnRoomIDs = useMemo(
		() =>
			rooms.value
				.filter((item) => Boolean(item.chillnnRoomID?.value))
				.map((roomType) => roomType.chillnnRoomID!.value!),
		[rooms.value],
	);

	const chillnnRoomIDOptions: (selectedRoomID: string | undefined) => FormOptionType[] = (selectedRoomID) => {
		return [
			{ id: "chillnnRoomIDOptions_0", label: "紐付けしない", value: NULL },
			...roomKVList
				.filter((item) => selectedRoomID === item.roomID || !selectedChillnnRoomIDs.includes(item.roomID))
				.map((room, idx) => {
					return {
						label: room.name,
						value: room.roomID,
						id: room.name + room.roomID + idx,
					} satisfies FormOptionType;
				}),
		] satisfies FormOptionType[];
	};

	const onSetChillnnRoomID = useCallback(
		(value: { tllRoomID: string; chillnnRoomID: string }) => {
			_onSetChillnnRoomID({
				tllRoomID: value.tllRoomID,
				chillnnRoomID: value.chillnnRoomID,
			});
		},
		[_onSetChillnnRoomID],
	);

	return {
		chillnnRoomIDOptions,
		onSetChillnnRoomID,
	};
};
